import { computed, onMounted, onUnmounted, ref } from 'vue';
import { DEFAULT_TIMEZONE, getZonedParts } from '@/js/core/utils/timezone';

function displayClockParts(value) {
  return getZonedParts(value, DEFAULT_TIMEZONE, { weekday: 'long', month: 'long' });
}
export function formatDisplayTime(value) {
  const { hour, minute, second } = displayClockParts(value);
  const hours24 = Number(hour);

  return `${hours24 % 12 || 12}:${minute}:${second} ${hours24 >= 12 ? 'PM' : 'AM'}`;
}
export function displayTimeSlots(value) {
  const time = formatDisplayTime(value);
  const slots = [...time].map(char => ({ char, isDigit: char >= '0' && char <= '9' }));

  if (time.indexOf(':') === 1) {
    slots.unshift({ char: '', isDigit: true });
  }

  return slots;
}
export function formatDisplayDate(value) {
  const { weekday, month, day } = displayClockParts(value);

  // `day` comes back zero-padded ('05'), which reads wrong in prose.
  return `${weekday}, ${month} ${Number(day)}`;
}
export function useDisplayClock() {
  const now = ref(Date.now());
  let timerId = null;

  const scheduleTick = () => {
    timerId = setTimeout(
      () => {
        now.value = Date.now();
        scheduleTick();
      },
      1000 - (Date.now() % 1000)
    );
  };

  onMounted(scheduleTick);
  onUnmounted(() => clearTimeout(timerId));

  return {
    time: computed(() => formatDisplayTime(now.value)),
    timeSlots: computed(() => displayTimeSlots(now.value)),
    date: computed(() => formatDisplayDate(now.value)),
  };
}
